import styled from 'styled-components/macro';
import {spacing} from '@mui/system';
import {Typography as MuiTypography, DialogActions} from '@mui/material';
import colors from '../../../../theme/colors';

const StyledModalActions = styled(DialogActions)`
  padding-bottom: 40px;
`;
const Typography = styled(MuiTypography)(spacing);

const StyledTitle = styled.div`
  &.type {
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 37px;
    letter-spacing: 0.6px;
    color: ${colors.neutral.black};

    margin-top: 34px;
    margin-bottom: 22px;
  }
`;

export {StyledModalActions, Typography, StyledTitle};
